export class DefaultRandomSource {
    next() {
        return Math.random();
    }
}
//# sourceMappingURL=random.js.map